import * as React from 'react';

interface Props {
  children: React.ReactNode;
}

export function ResultsFooterCell({ children }: Props): React.ReactElement {
  return (
    <div className="relative h-full flex items-center justify-center py-2 bg-grey-200 rounded-4px">
      <span className="h-8 text-sm font-500 leading-8 text-blue-900 pointer-events-none">
        {children}
      </span>
    </div>
  );
}
